module.exports = __webpack_public_path__ + "img/covid.a3285a6a.png";